module.exports = __webpack_public_path__ + "static/media/mcp.6c1e5511.png";